import { HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { EMPTY, catchError, throwError } from 'rxjs';

export const noStoreErrorResponseInterceptor: HttpInterceptorFn = (req, next) => { 
  const router = inject(Router);

  return next(req).pipe(
    catchError(response => {
      if (response.error?.message?.includes('Could not find store with name')) {
        if (!router.url.includes('/no-store-error')) {
          router.navigate(['no-store-error']);
        }
        return EMPTY;
      }
      return throwError(() => response);
    })
  );
};
